import Query from './query'
import withAuth from './with-auth'

export default withAuth(Query)
